import { Section, ChromeHeading, Card, GoldButton, OutlineGoldButton } from "../funnel";
import { EVENT_DAY_LABEL, EVENT_TIME_LABEL } from "../../config/event";
import { ICS_URL, ICS_FILENAME } from "../../lib/calendar";
import { TELEGRAM_URL } from "../../config/links";
import { scrollToId } from "../../lib/scroll";

const scrollToToolkit = () => scrollToId("toolkit");

const Step = ({ n, title, body, highlight, children }) => (
  <Card hover className={`flex h-full flex-col p-7 sm:p-8 ${highlight ? "!border-[var(--gold)] shadow-[0_0_40px_-8px_rgba(232,184,74,0.45)]" : ""}`} data-testid={`step-card-${n}`}>
    <p className="font-display gold-text text-7xl leading-none">{n}</p>
    <h3 className="mt-5 text-xl font-semibold leading-snug text-[#f4efe4]">{title}</h3>
    <p className="mt-3 flex-1 text-[15px] leading-relaxed text-[#b9b1a2]">{body}</p>
    <div className="mt-7">{children}</div>
  </Card>
);

export const ThreeThings = () => (
  <Section data-testid="three-things-section">
    <ChromeHeading className="text-4xl sm:text-5xl lg:text-6xl">Do these 3 things right now</ChromeHeading>
    <div className="mx-auto mt-12 grid max-w-md gap-5 lg:max-w-none lg:grid-cols-3">
      <Step n="1" title="Join the free community" body="Class reminders, the Zoom link and direct access to me and the team before we go live.">
        <OutlineGoldButton href={TELEGRAM_URL} target="_blank" rel="noopener noreferrer" className="w-full" data-testid="telegram-link">Join the Telegram community →</OutlineGoldButton>
      </Step>
      <Step n="2" title="Put it on your calendar" body={`The people who get results are the ones who show up live. Block the hour now, ${EVENT_DAY_LABEL} at ${EVENT_TIME_LABEL} ET.`}>
        <OutlineGoldButton href={ICS_URL} download={ICS_FILENAME} className="w-full" data-testid="calendar-link">Add to my calendar →</OutlineGoldButton>
      </Step>
      <Step n="3" highlight title="Walk in with the Toolkit" body="The same checklists and sequences I use with every client, so you can apply what you learn the same night.">
        <GoldButton onClick={scrollToToolkit} className="w-full" data-testid="see-toolkit-button">See what's inside · $37</GoldButton>
      </Step>
    </div>
  </Section>
);
